// CR-16: "Other (number of days)". The Start Date is Day 1, so Due Date = Start Date + (Days - 1).
// Calendar days: weekends and holidays count.

// A plain-words problem with the number of days, or '' when it is fine (or still empty).
export const durationError = (days) => {
  if (days === '' || days === null || days === undefined) return '';
  const n = Number(days);
  if (!Number.isInteger(n) || n < 1 || n > 365) return 'Enter a whole number of days from 1 to 365';
  return '';
};

// "yyyy-MM-dd" due date from a "yyyy-MM-dd" start date and a number of days, or '' if either is missing or wrong.
export const calcDueDate = (startDate, days) => {
  if (!startDate || days === '' || days === null || days === undefined || durationError(days)) return '';
  const [y, m, d] = String(startDate).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return '';
  return new Date(Date.UTC(y, m - 1, d + Number(days) - 1)).toISOString().slice(0, 10);
};

// Is the form set to "Other (number of days)"?
export const isOtherDuration = (formData) =>
  (formData.durationMode || (Number(formData.durationDays) > 0 ? 'other' : 'specific')) === 'other';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// "2026-10-24" -> "24 Oct 2026"
export const formatDayMonYear = (ymd) => {
  const [y, m, d] = String(ymd || '').slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return '';
  return `${String(d).padStart(2, '0')} ${MONTHS[m - 1]} ${y}`;
};
